import React, { useState } from "react";
import { Button, Input, Message } from "semantic-ui-react";
import { DISCOUNT_REASONS } from "../../../../utils/constants";
import "./DiscountForm.scss";

// Formulario de descuento o cortesía dentro de "Cobrar cuenta"
// (PaymentDetail.js). S/ fijo o %, con motivo obligatorio — queda registrado
// quién lo aplicó (Reportes → Anulaciones y descuentos).
export function DiscountForm(props) {
  const { onApply, onCancel } = props;
  const [type, setType] = useState("PERCENT");
  const [value, setValue] = useState("");
  const [reason, setReason] = useState(null);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const number = Number(value);
  const validValue = value !== "" && number > 0 && (type === "AMOUNT" || number <= 100);
  const needsNote = reason === "Otro" && !note.trim();
  const canApply = validValue && reason && !needsNote && !saving;

  const apply = async () => {
    setSaving(true);
    setError(null);
    try {
      const fullReason = note.trim() ? `${reason} — ${note.trim()}` : reason;
      await onApply({ type, value: number, reason: fullReason });
    } catch (err) {
      setError("No se pudo aplicar el descuento. Revisa tu conexión.");
      setSaving(false);
    }
  };

  // Cortesía = 100%: atajo de un toque.
  const courtesy = () => {
    setType("PERCENT");
    setValue("100");
    setReason("Cortesía de la casa");
  };

  return (
    <div className="discount-form">
      <div className="discount-form__row">
        <Button.Group size="small">
          <Button
            type="button"
            active={type === "PERCENT"}
            color={type === "PERCENT" ? "orange" : undefined}
            onClick={() => setType("PERCENT")}
          >
            %
          </Button>
          <Button
            type="button"
            active={type === "AMOUNT"}
            color={type === "AMOUNT" ? "orange" : undefined}
            onClick={() => setType("AMOUNT")}
          >
            S/
          </Button>
        </Button.Group>
        <Input
          type="number"
          min="0"
          max={type === "PERCENT" ? 100 : undefined}
          step="0.01"
          placeholder={type === "PERCENT" ? "Ej. 10" : "Ej. 5.00"}
          value={value}
          onChange={(_, data) => setValue(data.value)}
        />
        <Button type="button" basic size="small" onClick={courtesy}>
          Cortesía (100%)
        </Button>
      </div>
      {value !== "" && !validValue && (
        <p className="discount-form__hint">
          {type === "PERCENT" ? "Entre 1 y 100 %." : "Ingresa un monto mayor a 0."}
        </p>
      )}

      <p className="discount-form__label">Motivo</p>
      <div className="discount-form__reasons">
        {DISCOUNT_REASONS.map((text) => (
          <Button
            key={text}
            type="button"
            size="small"
            basic={reason !== text}
            color={reason === text ? "orange" : undefined}
            onClick={() => setReason(text)}
          >
            {text}
          </Button>
        ))}
      </div>
      {reason && (
        <Input
          fluid
          placeholder={reason === "Otro" ? "Explica el motivo" : "Detalle (opcional)"}
          value={note}
          maxLength={200}
          onChange={(_, data) => setNote(data.value)}
        />
      )}

      {error && <Message negative size="small">{error}</Message>}

      <div className="discount-form__actions">
        <Button type="button" basic onClick={onCancel}>
          Volver
        </Button>
        <Button type="button" color="orange" disabled={!canApply} loading={saving} onClick={apply}>
          Aplicar descuento
        </Button>
      </div>
    </div>
  );
}
